import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";

export default function GoalBottom(props) {
  const { col } = props;
  const curveResult = useSelector((state) => state.statehome.curveResult);
  const clusterResult = useSelector((state) => state.statehome.clusterResult);

  return (
    <Col sm={12} style={{ marginTop: "1rem" }}>
      <Row>
        {curveResult.length ? (
          <Col sm={12} md={12} lg={col[1]} xl={col[0]} xxl={col[0]}>
            <div
              className="card-university"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}
            >
              <div className="card-header">
                <h5>10S-Curve</h5>
                <p>จำนวน {curveResult.length}</p>
              </div>
              <div className="card-university-body">
                <div className="list">
                  {curveResult.map((data, index) => (
                    <div className="detail" key={index}>
                      <h6>
                        <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                      </h6>
                      <h6>
                        <b>ปัจจัย :</b> {data.curve_name}
                      </h6>
                      <hr className="line-researcher" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        ) : null}
        {clusterResult.length ? (
          <Col sm={12} md={12} lg={col[1]} xl={col[2]} xxl={col[2]}>
            <div
              className="card-university"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}
            >
              <div className="card-header">
                <h5>RMUTI Cluster</h5>
                <p>จำนวน {clusterResult.length}</p>
              </div>
              <div className="card-university-body">
                <div className="list">
                  {clusterResult.map((data, index) => (
                    <div className="detail" key={index}>
                      <h6>
                        <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                      </h6>
                      <h6>
                        <b>ปัจจัย :</b> {data.cluster_name}
                      </h6>
                      <hr className="line-researcher" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        ) : null}
      </Row>
    </Col>
  );
}
